import { Dispatch } from 'redux';

import { Invite, fetchInvite as apiFetchInvite } from 'api/invites';

import { MainStoreErrorAction, setError } from './error';

// Types

export type MainStoreInvitesState = {
  byId: Record<string, Invite & { isFetching: boolean }>;
};

type FetchInviteRequestAction = {
  type: 'FETCH_INVITE_REQUEST';
  inviteId: string;
};

type FetchInviteSuccessAction = {
  type: 'FETCH_INVITE_SUCCESS';
  invite: Invite;
};

export type MainStoreInvitesAction =
  | FetchInviteRequestAction
  | FetchInviteSuccessAction;

// Reducer

export function invitesReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: MainStoreInvitesState = {
    byId: {},
  },
  action: MainStoreInvitesAction,
) {
  switch (action.type) {
    case 'FETCH_INVITE_REQUEST':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.inviteId]: {
            ...state.byId[action.inviteId],
            id: action.inviteId,
            isFetching: true,
          },
        },
      };

    case 'FETCH_INVITE_SUCCESS':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.invite.id]: { ...action.invite, isFetching: false },
        },
      };

    default:
      return state;
  }
}

// Actions

const fetchInviteRequest = (inviteId: string): FetchInviteRequestAction => ({
  type: 'FETCH_INVITE_REQUEST',
  inviteId,
});

const fetchInviteSuccess = (invite: Invite): FetchInviteSuccessAction => ({
  type: 'FETCH_INVITE_SUCCESS',
  invite,
});

export const fetchInvite =
  (inviteId: string) =>
  (
    dispatch: Dispatch<MainStoreInvitesAction | MainStoreErrorAction>,
    getState: () => { invites: MainStoreInvitesState },
  ) => {
    const state = getState();
    const invite = state.invites.byId[inviteId];

    if (!invite) {
      dispatch(fetchInviteRequest(inviteId));
      apiFetchInvite(inviteId)
        .then((fetchedInvite) => {
          dispatch(fetchInviteSuccess(fetchedInvite));
        })
        .catch((e) => {
          dispatch(setError(e));
        });
    }
  };
